export default __webpack_public_path__ + "static/media/blue-lighten-historical.891c2490.svg";